// frontend_MainDashboard/src/hooks/api/useTemplateApi.ts

import { useCallback } from 'react';
import { useApiBase } from './useApiBase';
import {
  MessageTemplateCreatePayload,
  CreateTemplateResponse,
  FetchTemplatesResponse,
  SendTemplatedMessagePayload,
  SendTemplatedMessageApiResponse,
} from '@openmirror/shared';

export interface TemplateApiHook {
  createMessageTemplate: (templateData: MessageTemplateCreatePayload) => Promise<CreateTemplateResponse>;
  fetchMessageTemplates: () => Promise<FetchTemplatesResponse>;
  deleteMessageTemplate: (templateFirestoreId: string) => Promise<{ success: boolean; message?: string }>;
  sendTemplatedMessage: (payload: SendTemplatedMessagePayload) => Promise<SendTemplatedMessageApiResponse>;
}

export const useTemplateApi = (): TemplateApiHook => {
  const { makeRequest } = useApiBase();

  const createMessageTemplate = useCallback((templateData: MessageTemplateCreatePayload): Promise<CreateTemplateResponse> => {
    return makeRequest<CreateTemplateResponse, MessageTemplateCreatePayload>('/client/message_templates', 'POST', templateData);
  }, [makeRequest]);

  const fetchMessageTemplates = useCallback((): Promise<FetchTemplatesResponse> => {
    return makeRequest<FetchTemplatesResponse>('/client/message_templates', 'GET');
  }, [makeRequest]);
  
  const deleteMessageTemplate = useCallback((templateFirestoreId: string): Promise<{ success: boolean; message?: string }> => {
    return makeRequest<{ success: boolean; message?: string }>(`/client/message_templates/${templateFirestoreId}`, 'DELETE');
  }, [makeRequest]);
  
  const sendTemplatedMessage = useCallback((payload: SendTemplatedMessagePayload): Promise<SendTemplatedMessageApiResponse> => {
    return makeRequest<SendTemplatedMessageApiResponse, SendTemplatedMessagePayload>('/client/send_templated_message', 'POST', payload);
  }, [makeRequest]);

  return {
    createMessageTemplate,
    fetchMessageTemplates,
    deleteMessageTemplate,
    sendTemplatedMessage,
  };
};
